<script lang="ts">
  import SelectedItem from './SelectedItem.svelte'
  import { createEventDispatcher } from 'svelte'
  import useFilter from '../hooks/use-filter'
  import RemoveAll from './RemoveAll.svelte'
  import type { Filter } from '../global'
  import Label from './Label.svelte'

  export let label: string
  export let secondaryLabel: string
  export let items: Filter.SelectedFilter[]

  const { buttons } = useFilter()
  const dispatch = createEventDispatcher()
  const onClickAll = () => dispatch('removeall')
  const onClickFilter = (selected: Filter.SelectedFilter) => dispatch('removefilter', selected)
</script>

<div class="rounded-sm border border-gray-200 bg-white p-3">
  <div class="flex flex-col gap-3">
    <div>
      <Label as="span">{label}:</Label>
      <span>({secondaryLabel})</span>
    </div>
    <div class="flex flex-wrap gap-2">
      {#each items as item, i (`${item.key}-${i}`)}
        <SelectedItem on:click={() => onClickFilter(item)}>
          {item.text}
        </SelectedItem>
      {/each}
      <RemoveAll on:click={onClickAll}>
        <span class="block sm:hidden">{buttons.cancel.short}</span>
        <span class="hidden sm:block">{buttons.cancel.long}</span>
      </RemoveAll>
    </div>
  </div>
</div>
